import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { TownsFailure, TownsRequest, TownsReset, TownsSuccess } from './actions';
import { ParameterResult } from '@models/swagger';

export const featureKey = 'towns';

export interface State {
  data: ParameterResult[] | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: [],
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(TownsFailure, (state, { error }) => ({ ...state, data: [], error, loading: false })),
    on(TownsRequest, state => ({ ...state, error: null, loading: true })),
    on(TownsSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false })),
    on(TownsReset, state => ({ ...state, data: [] }))
  )(state, action);
}
